import * as THREE from "three";
import {FBXLoader} from "three/examples/jsm/loaders/FBXLoader";
import {createPanel} from "JQueryScripts/threejs/player-three-cpl";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";

let actions = [];

export const threeGenerateScene = async (sceneContainer) => {
    sceneContainer.show();

    const camera = new THREE.PerspectiveCamera(45, sceneContainer.width() / sceneContainer.height(), 1, 2000);
    camera.position.set(100, 200, 300);

    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0xa0a0a0);
    scene.fog = new THREE.Fog(0xa0a0a0, 0.1, 2000);

    const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444);
    hemiLight.position.set(0, 200, 0);
    scene.add(hemiLight);

    const dirLight = new THREE.DirectionalLight(0xffffff);
    dirLight.position.set(0, 200, 100);
    dirLight.castShadow = true;
    dirLight.shadow.camera.top = 180;
    dirLight.shadow.camera.bottom = -100;
    dirLight.shadow.camera.left = -120;
    dirLight.shadow.camera.right = 120;
    scene.add(dirLight);

    // ground
    const mesh = new THREE.Mesh(new THREE.PlaneGeometry(2000, 2000), new THREE.MeshPhongMaterial({
        color: 0x999999,
        depthWrite: false
    }));
    mesh.rotation.x = -Math.PI / 2;
    mesh.receiveShadow = true;
    scene.add(mesh);

    const grid = new THREE.GridHelper(2000, 20, 0x000000, 0x000000);
    grid.material.opacity = 0.2;
    grid.material.transparent = true;
    scene.add(grid);

    const mixer = await loadFbx(sceneContainer, scene);

    const controls = new OrbitControls(camera, sceneContainer[0]);
    controls.target.set(0, 100, 0);

    return {scene, camera, sceneContainer, mixer, controls};
}

const loadFbx = (sceneContainer, scene) => {
    return new Promise((resolve) => {
        const loader = new FBXLoader();

        loader.load(
            sceneContainer.data('url'),
            function (object) {
                let sceneMixer = new THREE.AnimationMixer(object);

                const action = sceneMixer.clipAction(object.animations[0]);
                actions.push(action);
                action.play();

                object.traverse(function (child) {

                    if (child.isMesh) {

                        child.castShadow = true;
                        child.receiveShadow = true;
                    }
                });
                createPanel(sceneContainer, actions, sceneMixer, scene);
                scene.add(object);

                resolve(sceneMixer);
            }
        );
    })
}